import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ApplicationOwnerItem } from '../application.owner.item';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { ApplicationBusinessInfo } from '../application.business.info';
import { distinctUntilChanged } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
    selector: 'app-owners-information',
    templateUrl: './owners-information.component.html',
    styleUrls: ['./owners-information.component.css', '../application.component.css']
})
export class OwnersInformationComponent implements OnInit {
    @Input() token: any;
    @Input() referralPage: any;
    @Input() businessEmail: any;
    @Input() statesIssued: any[] = [];
    @Input() appInfo: ApplicationBusinessInfo;
    @Input() owners: ApplicationOwnerItem[] = [new ApplicationOwnerItem(this.formBuilder)];
    @Output() backClicked = new EventEmitter<void>();
    @Output() continueClicked = new EventEmitter<any>();

    production: boolean = environment.production;
    cities: any[] = [];
    states: any[] = [];
    errorTitle = '';
    errorMessageA = '';
    errorMessageB = '';
    errorMessageC = '';
    googleVariant: any;
    googleExperience: any;
    errorMessageBClass = '';
    errorId = 'OwnPercentageE';
    zipValid = false;
    submitted = false;
    coSignerSubmitted = false;
    activeTab = 0;
    ownershipPercentage = 0;
    today = new Date();
    maxAgeDate = new Date((new Date()).setFullYear(new Date().getFullYear() - 18));
    coSignerInfo: ApplicationOwnerItem = new ApplicationOwnerItem(this.formBuilder);

    private user = JSON.parse(localStorage.getItem('logged_user'));

    constructor(
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder,
        private ref: ChangeDetectorRef,
        private googleAnalyticsService: GoogleAnalyticsService,
        private route: ActivatedRoute
    ) { }

    get buttonContinueDisabled() {
        let disabled = false;
        this.owners.forEach((owner: ApplicationOwnerItem) => {
            const ownerForm = owner.oForm;
            if (!ownerForm.creditAuth.value) {
                disabled = true;
            }
        });
        return disabled;
    }

    ngOnInit() {
        this.googleExperience = this.route.snapshot.queryParams.google_experience;
        this.googleVariant = this.route.snapshot.queryParams.google_variant;
        const ownerForm = this.owners[0].oForm;

        ownerForm.creditAuth.setValue(false);
        ownerForm.creditAuthTwo.setValue(false);

        this.avoidWhitespace();

        for (let index = 0; index < this.owners.length; index++) {
            this.onZipCodeKeyUp(this.owners[index].oForm, index).then(() => { void (0); }, () => { void (0); });
        }
    }

    changeSigner(owner: ApplicationOwnerItem) {
        this.owners.forEach(fOwner => {
            fOwner.oForm.authorize.setValue('false');
        });
        owner.oForm.authorize.setValue('true');
    }

    onZipCodeKeyUp(owner: any, id: any) {
        let zipcode = "";
        if (owner.zipCode.value != undefined && owner.zipCode.value != null) {
            zipcode = owner.zipCode.value != '' ? owner.zipCode.value : 0;
        } else {
            zipcode = owner.zipCode != '' ? owner.zipCode : 0;
        }

        return new Promise((resolve, reject) => {
            this.getZipCodeData(zipcode).then(
                (data: any) => {
                    if (data.object) {
                        this.zipValid = false;
                        this.states = this.statesIssued;
                        this.cities[id] = data.object.city;

                        owner.state.setValue(data.object.state);
                        owner.city.setValue(data.object.city[0]);

                        resolve(data);
                    } else {
                        this.cities[id] = [];
                        this.zipValid = true;
                        owner.city.setValue('');
                        reject();
                    }
                },
                (error: any) => {
                    this.cities[id] = [];
                    this.states = [];
                    owner.state.setValue('');
                    reject();
                }
            );
        });
    }

    onZipCodeKeyUpHandler(owner: any, id: any) {
        this.onZipCodeKeyUp(owner, id).then(
            () => { void (0); },
            () => { void (0); }
        );
    }

    getZipCodeData(zipCode: string) {
        return new Promise((resolve, reject) => {
            if (this.token) {
                this.connectionService.getRequestWithToken(`${environment.gateway}applicationNl/zipData/${zipCode}`, 'application/json', this.token).subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            } else {
                this.connectionService.getRequest(`${environment.gateway}application/zipData/${zipCode}`, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            }
        });
    }

    showVerifyInformationModal() {
        let invalid = false;

        this.ownershipPercentage = 0;
        this.submitted = true;
        this.owners.forEach((owner: ApplicationOwnerItem) => {
            this.ownershipPercentage += Number(owner.oForm.ownershipPercentage.value);
        });

        if (this.ownershipPercentage > 100 || this.ownershipPercentage < 51) {
            this.errorTitle = 'Sorry, we found a problem';
            this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
            this.errorMessageB = 'The total ownership percentage is ' + this.ownershipPercentage + '%, it must be between 51% and 100%';
            this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
            this.errorMessageBClass = 'mB20';
            $('#errorModalDialogOwnPercentageE').modal();
            return;
        }

        for (let index = 0; index < this.owners.length; index++) {
            this.owners[index].oForm.authorize.setValue(index == 0 ? 'true' : 'false');
        }

        this.owners[0].form.controls.email.setValue(this.businessEmail.value);

        this.owners.forEach((owner: ApplicationOwnerItem) => {
            if (owner.form.invalid) {
                invalid = true;
            }
        });

        if (invalid) {
            return;
        }

        $('#verifyInformationModal').modal();
    }

    onContinueClick(captcha) {
        let invalid = false;

        this.ownershipPercentage = 0;
        this.submitted = true;
        this.owners.forEach((owner: ApplicationOwnerItem) => {
            this.ownershipPercentage += Number(owner.oForm.ownershipPercentage.value);
        });

        if (this.ownershipPercentage > 100 || this.ownershipPercentage < 51) {
            this.errorTitle = 'Sorry, we found a problem';
            this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
            this.errorMessageB = 'The total ownership percentage is ' + this.ownershipPercentage + '%, it must be between 51% and 100%';
            this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
            this.errorMessageBClass = 'mB20';
            $('#errorModalDialogOwnPercentageE').modal();
            return;
        }

        for (let index = 0; index < this.owners.length; index++) {
            this.owners[index].oForm.authorize.setValue(index == 0 ? 'true' : 'false');
        }

        this.owners[0].form.controls.email.setValue(this.businessEmail.value);

        this.owners.forEach((owner: ApplicationOwnerItem) => {
            if (owner.form.invalid) {
                invalid = true;
            }
        });

        if (invalid) {
            return;
        }

        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', 'owner-information-completed', this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);

        this.continueClicked.emit({ owners: this.owners, captcha: captcha });
    }

    onBackClick() {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', 'back-to-business-information', this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);
        this.backClicked.emit();
    }

    onCompleteInformationClick(owner: ApplicationOwnerItem) {
        owner.setDefaultData();

        this.onZipCodeKeyUp(owner.form.controls, 0).then(() => {
            owner.setDefaultData();
        });
        this.owners[0].form.controls.authorize.setValue('true');
    }

    onAddOwnerClick() {
        this.owners.push(new ApplicationOwnerItem(this.formBuilder));
        $('#owner-tab-' + (this.owners.length - 1)).tab('show');
        this.avoidWhitespace();
    }

    onRemoveOwnerClick(owner: ApplicationOwnerItem) {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', 'co-signer-removed', this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);
        const index = this.owners.indexOf(owner);
        if (index > -1) {
            this.owners.splice(index, 1);
        }

        $('#owner-tab-0').tab('show');
    }

    getOwnerItem(event: any) {
        let customDimensions = {};
        customDimensions[environment.GA_DIMENSIONS.REFERRAL_PAGE] = this.referralPage;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_EXPERIENCE] = this.googleExperience ? this.googleExperience : undefined;
        customDimensions[environment.GA_DIMENSIONS.GOOGLE_VARIANT] = this.googleVariant ? this.googleVariant : undefined;
        this.googleAnalyticsService.trackEvent('application', 'co-signer-added', this.token ? 'application-token' : 'application', 1, this.token ? customDimensions : null);
        this.owners.push(new ApplicationOwnerItem(this.formBuilder));
        this.owners[this.owners.length - 1].form = event;
        this.onZipCodeKeyUp(this.owners[this.owners.length - 1].form.controls, this.owners.length - 1)

        $('#owner-tab-' + (this.owners.length - 1)).tab('show');

        this.avoidWhitespace();
    }

    addCosigner() {
        this.ownershipPercentage = 0;
        this.coSignerSubmitted = false;
        this.coSignerInfo = new ApplicationOwnerItem(this.formBuilder);
        this.owners.forEach((owner: ApplicationOwnerItem) => {
            this.ownershipPercentage += Number(owner.oForm.ownershipPercentage.value);
        });
    }

    onSetSameBusiness(id: number) {
        const appInfo = this.appInfo.form.controls;

        if (!this.owners[id].oForm.sameAsBusiness.value) {
            this.owners[id].oForm.zipCode.setValue(appInfo.zip.value)
            this.owners[id].oForm.city.setValue(appInfo.city.value)
            this.owners[id].oForm.homeAddress.setValue(appInfo.businessAddress.value)
            this.owners[id].oForm.state.setValue(appInfo.state.value)
            this.onZipCodeKeyUp(this.owners[id].oForm, id);
        }
        this.disableInputsBusiness(this.owners[id]);
    }

    private disableInputsBusiness(form: ApplicationOwnerItem) {
        form.oForm.sameAsBusiness.value ? form.oForm.city.enable() : form.oForm.city.disable();
        form.oForm.sameAsBusiness.value ? form.oForm.zipCode.enable() : form.oForm.zipCode.disable();
        form.oForm.sameAsBusiness.value ? form.oForm.homeAddress.enable() : form.oForm.homeAddress.disable();
        form.oForm.sameAsBusiness.value ? form.oForm.state.enable() : form.oForm.state.disable();
    }

    private avoidWhitespace() {
        this.owners.forEach((owner: ApplicationOwnerItem) => {
            owner.form.controls.firstName.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
                owner.form.controls.firstName.setValue((res).trimStart());
            });
            owner.form.controls.lastName.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
                owner.form.controls.lastName.setValue((res).trimStart());
            });
            owner.form.controls.zipCode.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
                owner.form.controls.zipCode.setValue((res).trimStart());
            });
            owner.form.controls.homeAddress.valueChanges.pipe(distinctUntilChanged()).subscribe(res => {
                owner.form.controls.homeAddress.setValue((res).trimStart());
            });
        });
    }
}
